import { freezeObject } from '../../utils/utils'

/**
 * FreezeObject() is used for making those constants un
 */
export const FORMATS = freezeObject({
  // Display formats (Croatian convention — trailing period on date)
  date: 'DD.MM.YYYY.',
  time: 'HH:mm:ss',
  timeShort: 'HH:mm',
  datetime: 'DD.MM.YYYY. HH:mm:ss',
  datetimeShort: 'DD.MM.YYYY. HH:mm',

  // ISO / standard API formats
  isoDate: 'YYYY-MM-DD',
  isoDatetime: 'YYYY-MM-DD HH:mm:ss',
  standard: 'YYYY-MM-DD HH:mm',

  // Compact DMY formats (no trailing period — used in some API calls and picker components)
  dateCompact: 'DD.MM.YYYY',
  datetimeCompact: 'DD.MM.YYYY HH:mm',
  datetimeCompactLong: 'DD.MM.YYYY HH:mm:ss',

  // Day-name formats (used in human-readable notes and messages)
  dateWithDay: 'DD.MM.YYYY (dddd)',
  dateWithDayAlt: 'DD.MM.YYYY, dddd',

  // File-name suffix for exports
  filename: 'YYYYMMDDHHmmss',

  // other date format variants
  dateSlashShort: 'D/M/YY'
})

export const DIFF_UNITS = freezeObject([
  'millisecond', 'second', 'minute', 'hour',
  'day', 'week', 'month', 'quarter', 'year'
])

export const ENGLISH_LOCALES = freezeObject([
  'en-au', 'en-bz', 'en-ca', 'en-cb', 'en-gb',
  'en-in', 'en-ie', 'en-jm', 'en-nz', 'en-ph',
  'en-za', 'en-tt', 'en-us'
])
